<template>
    <div>
        <page-title>续费记录</page-title>
        <page-body>
            <list-header>
                <div flex="dir:left box:last cross:center">
                    <div>
                        <el-form :inline="true">
                            <el-form-item style="margin-bottom: 0; margin-top: 1px">
                                <el-date-picker
                                        size="mini"
                                        @change="dateChange"
                                        v-model="date"
                                        type="datetimerange"
                                        value-format="yyyy-MM-dd HH:mm:ss"
                                        range-separator="至"
                                        start-placeholder="开始日期"
                                        end-placeholder="结束日期">
                                </el-date-picker>
                            </el-form-item>
                            <el-form-item style="margin-bottom: 0; max-width: 150px">
                                <el-input v-model="keyword"
                                          @keyup.enter.native="search()"
                                          size="mini"
                                          placeholder="站点名称/域名"
                                          suffix-icon="el-icon-search"/>
                            </el-form-item>
                        </el-form>
                    </div>
                </div>
            </list-header>
            <el-table v-loading="loading" :data="list" style="width: 100%">
                <el-table-column prop="name" label="站点">
                    <template slot-scope="scope">
                        <div>{{scope.row.host.domain}}</div>
                        <div style="font-size: 12px;color: #909090">{{scope.row.host.name}}</div>
                        <view-certificate v-if="scope.row.certificate_url" v-model="scope.row.certificate_url" :mark="scope.row.mark"></view-certificate>
                    </template>
                </el-table-column>
                <el-table-column prop="name" label="续费人">
                    <template slot-scope="scope">
                        <div>{{scope.row.user.name}}</div>
                    </template>
                </el-table-column>
                <el-table-column prop="created_at" label="续费金额" width="160">
                    <template slot-scope="scope">
                            <div style="color: #909399; font-size: 12px;">{{scope.row.price}}元</div>
                    </template>
                </el-table-column>
                <el-table-column prop="created_at" label="续费时间" width="160">
                    <template slot-scope="scope">
                            <div style="color: #909399; font-size: 12px;">{{scope.row.created_at}}</div>
                    </template>
                </el-table-column>
                <el-table-column prop="created_at" label="时间" width="160">
                    <template slot-scope="scope">
                        <el-tooltip class="item" content="开始时间" placement="left">
                            <div style="color: #909399; font-size: 12px;">{{scope.row.start_time}}</div>
                        </el-tooltip>
                        <el-tooltip class="item" content="到期时间" placement="left">
                            <div style="color: #909399; font-size: 12px;">{{scope.row.end_time}}</div>
                        </el-tooltip>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination
                    style="margin: 20px -5px;padding: 0"
                    background
                    layout="prev, pager, next"
                    @current-change="pageChange"
                    :total="parseInt(pagination && pagination.totalCount ? pagination.totalCount : 0)">
            </el-pagination>
        </page-body>
    </div>
</template>

<style scoped>
    @media screen and (max-width: 767px) {
        .list-header {
            padding: 0.5rem 0.2rem;
        }
    }
</style>

<script>
import axios from '@/axios'

export default {
    components: {
        'HostTest': () => import('@/components/HostTest.vue'),
        'ViewCertificate': () => import('@/components/ViewCertificate.vue')
    },
    data() {
        return {
            showHostTestDialog: false,
            loading: false,
            list: null,
            pagination: null,
            keyword: '',
            host_id: null,
            user_id: null,
            date: null,
            start_at: null,
            end_at: null
        }
    },
    created() {
        this.host_id = this.$route.query.host_id || null
        this.user_id = this.$route.query.user_id || null
        this.loadData(0)
    },
    methods: {
        loadData(page) {
            if (this.date) {
                this.start_at = this.date[0]
                this.end_at = this.date[1]
            } else {
                this.start_at = null
                this.end_at = null
            }
            this.getList(page).then(e => {
                this.list = e.list
                this.pagination = e.pagination
            })
        },
        getList(page) {
            return new Promise(resolve => {
                this.loading = true
                axios({
                    url: 'admin/renew/index',
                    params: {
                        page: page,
                        keyword: this.keyword,
                        host_id: this.host_id,
                        user_id: this.user_id,
                        start_at: this.start_at,
                        end_at: this.end_at
                    }
                }).then(e => {
                    this.loading = false
                    if (e.data.code === 0) {
                        resolve(e.data.data)
                    } else {
                        this.$message.error(e.data.msg)
                    }
                })
            })
        },
        search() {
            this.loadData(0)
        },
        pageChange(page) {
            this.loadData(page - 1)
        },
        dateChange() {
            this.loadData(0)
        }
    }
}
</script>
